import type { PublicTenant } from './schemas';

function upsert(selector: string, create: () => HTMLElement, apply: (el: HTMLElement) => void) {
  let el = document.head.querySelector<HTMLElement>(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  apply(el);
}

const meta = (name: string, content: string) =>
  upsert(`meta[name="${name}"]`, () => Object.assign(document.createElement('meta'), { name }), (el) => el.setAttribute('content', content));

/**
 * Keeps document metadata on the current studio. Per-tenant static shells
 * (generated at build) already contain the same tags; this covers client-side
 * navigation and studios published after the last deploy.
 */
export function applyTenantHead(t: PublicTenant, area: 'client' | 'owner', themeColor = t.branding.theme_color, scheme: 'dark' | 'light' = 'dark') {
  document.title = area === 'owner' ? `${t.name} — кабинет` : t.name;
  meta('description', t.tagline || t.description.slice(0, 160));
  meta('theme-color', themeColor);
  meta('color-scheme', scheme);
  meta('apple-mobile-web-app-title', t.name.slice(0, 30));
  meta('application-name', t.name);
  meta('referrer', 'no-referrer');
  const staticShell = document.head.querySelector('meta[name="tenant-shell"]')?.getAttribute('content') === t.slug;
  if (!staticShell && t.logo) {
    upsert('link[rel="apple-touch-icon"]', () => Object.assign(document.createElement('link'), { rel: 'apple-touch-icon' }), (el) => el.setAttribute('href', t.logo!.url));
    upsert('link[rel="icon"]', () => Object.assign(document.createElement('link'), { rel: 'icon' }), (el) => el.setAttribute('href', t.logo!.url));
  }
}
